// Canonical session title resolver (Feature 1: title sync).
//
// Every UI surface — cards on /events, the Founder Labs detail page, the
// standalone share view, admin lists, dashboards, emails — must read from this
// single helper so a title edit propagates everywhere immediately.
//
// Precedence:
//   1. The series's saved `title` (whatever the admin typed, verbatim).
//   2. Auto default: "Capital Series with {investor_name}".
//   3. Bare investor_name if nothing else is available.
export function sessionTitle(series) {
  if (!series || typeof series !== "object") return "";
  const t = (series.title || "").trim();
  if (t) return t;
  const name = (series.investor_name || "").trim();
  return name ? `Capital Series with ${name}` : "";
}

// True when the title is server-marked as auto-generated (admin never set one).
// Callers can surface an "auto" chip so admins spot untyped titles.
export function isAutoTitle(series) {
  return series && series.title_source === "auto";
}
